module.exports = __webpack_public_path__ + "static/media/CBERS 4.3bb3640b.czml";